import React from "react";
import { Grid2 } from "@mui/material";
import { SearchTextParamName } from "types";
import { FilterRow, FilterWrapper } from "components";
import { BooleanFilter } from "modules/shared/filters/BooleanFilter";
import { SearchTextFilter } from "modules/shared/filters/SearchTextFilter";

export const ExpansionProductListFilter: React.FC = () => (
  <FilterWrapper>
    <FilterRow>
      <Grid2>
        <BooleanFilter
          param="isProductActive"
          paramName="Aktiv"
          defaultOption="true"
        />
      </Grid2>
      <Grid2>
        <SearchTextFilter
          searchTextParamName={SearchTextParamName.SearchProduct}
        />
      </Grid2>
      <Grid2>
        {/* Der Param-Name muss lastStorePriceCalcSuccess bleiben: der Filter
            wird nur durchgelassen, wenn isKeyOfProduct(key) zutrifft. */}
        <BooleanFilter
          param="lastStorePriceCalcSuccess"
          paramName="Preis erfolgreich"
        />
      </Grid2>
    </FilterRow>
  </FilterWrapper>
);
